import React, { useState, useEffect } from "react"; // Make sure both useState and useEffect are imported
import { FaArrowRight } from "react-icons/fa";

function Prospectus() {
  const [currentDocuments, setCurrentDocuments] = useState([]);
  const [archivedDocuments, setArchivedDocuments] = useState([]);
  const [selectedPdf, setSelectedPdf] = useState(null);

  useEffect(() => {
    const fetchPolicyData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_Backend_URL}/prospectus/ProspectusDocument`
        );

        if (response.ok) {
          const result = await response.json();
          if (result.success) {
            setCurrentDocuments(result.data.current);
            setArchivedDocuments(result.data.archived);
          } else {
            console.error("Failed to fetch shareholding data.");
          }
        } else {
          console.error(`Error fetching data: ${response.statusText}`);
        }
      } catch (error) {
        console.error("Error fetching shareholding data:", error);
      }
    };

    fetchPolicyData();
  }, []);

  const handleViewClick = (fileUrl) => {
    setSelectedPdf(fileUrl);
  };

  const handleClosePreview = () => {
    setSelectedPdf(null);
  };

  return (
    <>
      <div className="banner-shareholding">
        <div className="overlay-shareholding" />
        <div className="banner-content animate__animated animate__fadeIn">
          <h1 className="h1-shareholding1">Prospectus</h1>
        </div>
      </div>
      <br />
      <br />
      <section className="pdf-links">
        <h2>Policy Reports</h2>
        <ul>
          {currentDocuments.length === 0 ? (
            <li>No current financial data available. Please check back later.</li>
          ) : (
            currentDocuments.map((doc) => (
              <li key={doc._id}>
                <div className="pdf-item">
                  <p className="year-title">
                    {doc.title} - {doc.year}
                  </p>
                  <a
                    href={doc.file}
                    className="view-link"
                    onClick={() => handleViewClick(doc.file)}
                  >
                    <FaArrowRight />
                  </a>
                </div>
              </li>
            ))
          )}
        </ul>
      </section>
    </>
  );
}

export default Prospectus;
